import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getStatus } from '../../actions/deviceActions';

export function BadgesWithoutRouter(props) {
  const { devices = {} } = props;
  const { status = { statuses: [] } } = devices;
  const { statuses = [] } = status;
  const deviceStatuses = useMemo(() => {
    const onlineDevices = statuses.filter(el => el.online_status === 'online');
    const offlineDevices = statuses.filter(el => el.online_status === 'offline');
    const uptodateDevices = statuses.filter(el => el.download_status === 'current');
    const outdatedDevices = statuses.filter(el => el.download_status === 'outdated');

    return {
      onlineDevices,
      offlineDevices,
      uptodateDevices,
      outdatedDevices,
    };
  }, [devices]);

  useEffect(() => {
    const { getStatus } = props;

    getStatus();
  }, []);

  return (
    <div className="md:flex md:justify-between grid  grid-cols-2 gap-y-2 justify-items-center">
      <Link
        to="/devices?online_status=online"
        className="flex w-[140px] h-[80px] md:w-[219px] 2xl:w-[270px] bg-white shadow-md  justify-around items-center rounded-lg"
      >
        <div className="pt-1">
          <p className="poppins-bold font-700 text-[#00243E] text-[12px] md:text-[16px]   mb-0">
            Online Devices
          </p>
          <p
            data-test="online-devices-value"
            className="poppins-bold font-700 text-[#00243E] text-[16px] md:text-[28px]   text-center mb-0"
          >
            {deviceStatuses.onlineDevices.length}
          </p>
        </div>
        <div className="w-[34px] h-[34px] rounded-full bg-[#39A757]" />
      </Link>

      <Link
        to="/devices?online_status=offline"
        className="flex w-[140px] md:w-[219px] 2xl:w-[270px]  h-[80px]  bg-white shadow-md   justify-around items-center rounded-lg"
      >
        <div className="pt-1">
          <p className="poppins-bold font-700 text-[#00243E] text-[12px] md:text-[16px] mb-0">
            Offline Devices
          </p>
          <p
            data-test="offline-devices-value"
            className="poppins-bold font-700 text-[#00243E] text-[16px] md:text-[28px] text-center mb-0"
          >
            {deviceStatuses.offlineDevices.length}
          </p>
        </div>

        <div className="w-[34px] h-[34px] rounded-full bg-red-500" />
      </Link>

      <Link
        to="/devices?download_status=current"
        className="flex w-[140px] h-[80px]  md:w-[219px] 2xl:w-[270px] bg-white shadow-md  justify-around items-center rounded-lg"
      >
        <div className="pt-1">
          <p className="poppins-bold font-700 text-[#00243E] text-[12px] md:text-[16px]   mb-0">
            Up To Date Content
          </p>
          <p
            data-test="uptodate-devices-value"
            className="poppins-bold font-700 text-[#00243E] text-[16px] md:text-[28px]   text-center mb-0"
          >
            {deviceStatuses.uptodateDevices.length}
          </p>
        </div>
        <img
          src="/assets/images/icons/up_to_date_content.svg"
          alt="network layer icon"
          className="md:w-[46px] md:h-[57px] w-[34px] h-[34px] p-1"
        />
      </Link>

      <Link
        to="/devices?download_status=outdated"
        className="flex w-[140px] h-[80px] md:w-[219px] 2xl:w-[270px] bg-white shadow-md  justify-around items-center rounded-lg"
      >
        <div className="pt-1">
          <p className="poppins-bold font-700 text-[#00243E] text-[12px] md:text-[16px]  mb-0">
            Outdated Content
          </p>
          <p
            data-test="outdated-devices-value"
            className="poppins-bold font-700 text-[#00243E] text-[16px] md:text-[28px]  text-center mb-0"
          >
            {deviceStatuses.outdatedDevices.length}
          </p>
        </div>
        <img
          src="/assets/images/icons/outdated_content.svg"
          alt="downloaded content icon"
          className="md:w-[46px] md:h-[57px] w-[34px] h-[34px] p-1"
        />
      </Link>
    </div>
  );
}

BadgesWithoutRouter.propTypes = {
  devices: PropTypes.object.isRequired,
  getStatus: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
  devices: state.devices,
});
const mapDispatchToProps = {
  getStatus,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BadgesWithoutRouter));
